/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_WhitespaceInputs */



/**
* | output |
* | --- |
* | "Extra whitespace" |
*
* @param {Qc_Fix_WhitespaceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_whitespace = /** @type {((inputs?: Qc_Fix_WhitespaceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_WhitespaceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espaces superflus")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überflüssige Leerzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazi bianchi in eccesso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лишние пробелы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacios en blanco adicionales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("多余的空白")
	if (locale === "ja") return /** @type {LocalizedString} */ ("余分な空白")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अतिरिक्त रिक्त स्थान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaços em branco a mais")
	return /** @type {LocalizedString} */ ("Extra whitespace")
});